import React from 'react';

export default function Contact() {
  const mapUrl = 'https://www.google.com/maps?rlz=1C5CHFA_enIN967IN968&gs_lcrp=EgZjaHJvbWUyBggAEEUYOdIBCDM5MjlqMGo3qAIAsAIA&um=1&ie=UTF-8&fb=1&gl=in&sa=X&geocode=KXUID3KU7zU6MbcrQT91XIAO&daddr=23-11-44,+Nageswara+Rao+Pantulu+Rd,+near+Raja+Ghee,+Shivaji,+Vijayawada,+Andhra+Pradesh+520002';

  return (
    <main className="contact-page">
      <section className="contact-hero">
        <p className="eyebrow">We would love to hear from you</p>
        <h1>Contact Starlight Threading</h1>
        <p>For styling help, custom measurements, order updates, or delivery questions, reach out to our team.</p>
      </section>
      <section className="contact-details-grid">
        <div className="contact-detail-card">
          <span className="contact-card-kicker">Call us</span>
          <h2>8309158686</h2>
          <a className="contact-action" href="tel:+918309158686">Call now</a>
        </div>
        <div className="contact-detail-card contact-address-card">
          <span className="contact-card-kicker">Visit us</span>
          <h2>Our studio</h2>
          <address>23-11-44, Nageswara Rao Pantulu Rd,<br />near Raja Ghee, Shivaji,<br />Vijayawada, Andhra Pradesh 520002</address>
          <a className="contact-action" href={mapUrl} target="_blank" rel="noreferrer">Open in Google Maps ↗</a>
        </div>
      </section>
    </main>
  );
}
